// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falI: CreateIconOptions = {
  "displayName": "FALI",
  "viewBox": "0, 0, 320, 512",
  "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l128 0 0 384L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-384 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 32 16 32z"
};
